export const PROMPT_NODE_OPTIONS = [
  { scenarioKey: 'semantic_search', promptNodeKey: 'intent_parse', label: '意图识别' },
  { scenarioKey: 'vector_ingest', promptNodeKey: 'image_analyze', label: '图片语义提取' },
]

export function isPromptEditable(prompt) {
  const locallyEditable = Boolean(prompt?.status === 'draft' && !prompt?.isActive && !Number(prompt?.firstUsedAt || 0))
  return typeof prompt?.editable === 'boolean' ? prompt.editable && locallyEditable : locallyEditable
}

export function promptReadOnlyMessage(prompt) {
  const reason = prompt?.readOnlyReason || (prompt?.isActive
    ? 'active'
    : Number(prompt?.firstUsedAt || 0) > 0
      ? 'first_used'
      : prompt?.status !== 'draft'
        ? prompt?.status
        : '')
  return {
    active: '当前生效版本不可修改或归档，请先发布并启用替代版本。',
    first_used: '此版本已被运行引用，内容不可修改；可复制为新草稿，也可归档保留历史记录。',
    published: '已发布版本内容只读，可设为生效、归档或复制。',
    archived: '已归档版本只读，可复制为新草稿。',
  }[reason] || ''
}

export function promptLifecycleActions(prompt) {
  const editable = isPromptEditable(prompt)
  const readOnlyMessage = promptReadOnlyMessage(prompt)
  return {
    clone: { visible: true, enabled: true, reason: '' },
    save: { visible: prompt?.status === 'draft', enabled: editable, reason: editable ? '' : readOnlyMessage },
    publish: { visible: prompt?.status === 'draft', enabled: editable, reason: editable ? '' : readOnlyMessage },
    activate: { visible: prompt?.status === 'published' && !prompt?.isActive, enabled: true, reason: '' },
    archive: {
      visible: !prompt?.isActive && prompt?.status !== 'archived',
      enabled: true,
      reason: '',
    },
    readOnlyMessage,
  }
}

export function orderedSystemPromptBlocks(prompt) {
  const blocks = Array.isArray(prompt?.systemPromptBlocks) ? prompt.systemPromptBlocks : []
  const byKey = new Map(blocks.map(block => [block.key, block]))
  return (prompt?.systemRenderOrder || []).map(key => byKey.get(key)).filter(Boolean)
}

export function parsePromptJson(value, label) {
  try {
    const parsed = JSON.parse(value)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error()
    return parsed
  } catch {
    throw new Error(`${label}必须是 JSON 对象`)
  }
}

export function parsePromptStringArray(value, label) {
  try {
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed) || parsed.some(item => typeof item !== 'string')) throw new Error()
    return parsed
  } catch {
    throw new Error(`${label}必须是字符串数组`)
  }
}

export function promptTestInputTemplate(prompt) {
  const schema = prompt?.variablesSchema || {}
  const required = Array.isArray(schema.required) ? schema.required : []
  return JSON.stringify(Object.fromEntries(required.map(key => [key, promptTestDefaultValue(key)])), null, 2)
}

function promptTestDefaultValue(key) {
  return {
    pool_profile: '内容池 ID: test\n名称: 测试内容池\n描述: 无',
    enabled_dimensions: ['title_body', 'image', 'comment', 'ops_review'],
  }[key] ?? ''
}

export function promptTestResultState(result) {
  if (!result) return { tone: 'empty', label: '尚未测试' }
  if (result.status === 'running') return { tone: 'warning', label: '调用未完成' }
  if (result.schemaValid && result.status === 'success') return { tone: 'success', label: '结构有效' }
  if (result.errorCode && result.errorCode !== 'schema_invalid') return { tone: 'error', label: 'Provider 失败' }
  return { tone: 'warning', label: '结构无效' }
}

export function promptStatusLabel(prompt) {
  if (prompt?.isActive) return '当前生效'
  return { draft: '草稿', published: '已发布', archived: '已归档' }[prompt?.status] || prompt?.status || '-'
}

export function eventLabel(type) {
  return {
    new_draft: '新建草稿',
    clone: '复制草稿',
    save_draft: '保存草稿',
    publish: '发布',
    activate: '设为生效',
    deactivate: '取消生效',
    archive: '归档',
    archive_on_activate: '生效切换归档',
    test: '版本测试',
  }[type] || type
}
